/* eslint-disable */
import React, {SyntheticEvent} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import useMediaQuery from '@mui/material/useMediaQuery';
import {useTheme} from '@mui/material/styles';
import {AppBar, Box, Button, DialogActions, IconButton, MenuItem, Toolbar, Typography, Grid, Paper} from '@mui/material';
import {Icon} from '@iconify/react';
import CloseIcon from '@mui/icons-material/Close';
import {LoadingButton} from '@mui/lab';
import {useTranslation} from 'react-i18next';
import {Form} from 'react-final-form';
import {FilepondWrapper} from '@/components/forms';
import SimpleSpinner from "@/components/spinner/simpleSpinner";

const MenuItemModalForm = ({hasMenuItem, label, title, formFields, onSubmit, initialValues, validateForm, submitting, required, isUpload, component, children, resetForm, getFormFields, icon, callback, closePopover, buttonSaveProps, otherComponent, setModalOpen, loading}: any): any => {
	const {t} = useTranslation();
	const [open, setOpen] = React.useState(false);
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

	// fix is property is not loaded
	if (loading === undefined || loading === null) loading = false;

	const handleClickOpen = (form: any) => {
		setOpen(true);

		if (setModalOpen) {
			setModalOpen(true);
		}

		if (form) {
			form.reset();
			form.restart();
		}
	};

	const handleClose = (form: any) => {
		setOpen(false);

		if (setModalOpen) {
			setModalOpen(false);
		}

		if (closePopover) {
			closePopover();
		}

		if (form) {
			form.reset();
			form.restart();
		}
	};

	const handleSubmitClose = (_e: SyntheticEvent, handleSubmit: any, values: any, form: any, errors: any) => {
		console.log('handleSubmitClose');

		if (Object.keys(errors).length === 0) {
			console.log('No errors submit');
			handleSubmit(values)
				.then((response: any) => {
					if (response) {
						if (callback) {
							callback();
						}

						handleClose(form);
						return true;
					}
				})
				.finally(() => resetForm && form.restart());
		} else {
			console.log('Errors submit');
			handleSubmit(values);
			return false;
		}
	};

	return (
		<>
			<Form
				onSubmit={onSubmit}
				initialValues={initialValues}
				validate={validateForm}
				render={({handleSubmit, errors, values, touched, form}) => {
					/*console.log('modal form errors:', errors)
                    console.log('modal form touched:', touched)
                    console.log('modal form required:', required)*/

					const formFieldsFromParent: any[] = getFormFields ? getFormFields(values) : formFields;

					return (
						<form onSubmit={handleSubmit} noValidate style={{marginBottom: 0}}>
							{hasMenuItem && (
								<MenuItem onClick={() => handleClickOpen(form)} sx={{typography: 'body2', py: 1, px: 2.5}}>
									<Box
										component={Icon}
										sx={{
											mr: 2,
											width: 24,
											height: 24,
										}}
									/>
									{label}
								</MenuItem>
							)}

							{!hasMenuItem && <div onClick={() => handleClickOpen(form)}>{icon}</div>}

							<Dialog
								TransitionProps={{mountOnEnter: true, unmountOnExit: true}}
								disableEscapeKeyDown
								scroll={'paper'}
								fullScreen={fullScreen}
								fullWidth
								open={open}
								maxWidth={'md'}
								aria-labelledby="responsive-dialog-title"
								onClose={(_, reason) => {
									if (reason !== 'backdropClick') {
										handleClose(form);
									}
								}}
							>
								<AppBar sx={{position: 'relative'}}>
									<Toolbar>
										<IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
											<CloseIcon />
										</IconButton>
										<Typography sx={{ml: 2, flex: 1}} variant="h6" component="div">
											{title}
										</Typography>
									</Toolbar>
								</AppBar>

								<DialogContent style={{background: 'white', padding: '50px'}}>
									{ loading && <SimpleSpinner/>}
									{ !loading &&
									<>
										{/* <Grid container spacing={2}> */}
										{component && component}

										{formFieldsFromParent &&
											formFieldsFromParent.map((item: any, idx: number) => (
												<div key={idx}>
													{item.field === 'ponds' ? (
														<>
															{item.values.map((pond: any, index: number) => {
																/*console.log(pond.formFieldName);
                                                                console.log(errors[`${pond.formFieldName}`]);
                                                                console.log(touched[`${pond.formFieldName}`]);
                                                                console.log(required[`${pond.formFieldName}`]);*/
																return (
																	<Box key={'box-ck-' + index}>
																		<FilepondWrapper key={'pond-ck-' + index} authorization={pond.authorization} {...pond} hasError={errors[`${pond.formFieldName}`]} isTouched={touched[`${pond.formFieldName}`]} required={required[`${pond.formFieldName}`]} />
																	</Box>
																);
															})}
														</>
													) : (
														<>{item.field}</>
													)}
												</div>
											))}

										{otherComponent && otherComponent}
										{/* </Grid> */}
									</>
									}
								</DialogContent>

								<DialogActions sx={{overflowX: 'hidden', justifyContent: 'space-between', alignItems: 'center', pl: 3, pr: 3}}>
									<Button onClick={() => handleClose(form)} variant={'outlined'}>
										{t('common.close')}
									</Button>

									{!buttonSaveProps && (
										<LoadingButton
											size="medium"
											type="submit"
											variant="contained"
											loading={submitting}
											onClick={(e) => handleSubmitClose(e, handleSubmit, values, form, errors)}
											//onClick={handleSubmit}
										>
											{isUpload ? t('common.upload') : t('common.save')}
										</LoadingButton>
									)}

									{buttonSaveProps && (
										<LoadingButton
											size={buttonSaveProps?.size || 'medium'}
											type="submit"
											variant={buttonSaveProps?.variant || 'contained'}
											loading={submitting}
											onClick={(e) => handleSubmitClose(e, handleSubmit, values, form, errors)}
											//onClick={handleSubmit}
										>
											{buttonSaveProps?.text || (isUpload ? t('common.upload') : t('common.save'))}
										</LoadingButton>
									)}

									{children}
								</DialogActions>
							</Dialog>
						</form>
					);
				}}
			/>
		</>
	);
};

export default MenuItemModalForm;
